import cardValidator from 'card-validator';
import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { AmexIcon, DiscoverIcon, MastercardIcon, VisaIcon } from '@uplift/icons';

const useStyles = makeStyles()(theme => ({
  creditCards: {
    marginBottom: theme.spacing(3),
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  disabled: {
    filter: 'grayscale(100%) opacity(58%)'
  }
}));

export type CreditCardValidatorProps = {
  cardNumber?: string;
  className?: string;
  singleCard?: boolean;
};

export const CreditCardValidator: React.VFC<CreditCardValidatorProps> = React.memo(({ cardNumber, className, singleCard }) => {
  const { classes, cx } = useStyles();

  const setClass = React.useCallback((cardType: boolean) => {
    if (!cardNumber || !/\d/.test(cardNumber)) {
      return undefined;
    }

    if (!cardType) {
      return classes.disabled;
    }

    return undefined;
  }, [ cardNumber, classes.disabled ]);

  const { card } = cardValidator.number(cardNumber);

  const isVisa = card?.type === 'visa';
  const isMC = card?.type === 'mastercard';
  const isAmex = card?.type === 'american-express';
  const isDiscover = card?.type === 'discover';

  if (singleCard) {
    return (
      <div className={cx(classes.creditCards, className)}>
        {isVisa && <VisaIcon className={setClass(isVisa)} />}
        {isMC && <MastercardIcon className={setClass(isMC)} />}
        {isDiscover && <DiscoverIcon className={setClass(isDiscover)} />}
        {isAmex && <AmexIcon className={setClass(isAmex)} />}
      </div>
    );
  }

  return (
    <div className={cx(classes.creditCards, className)}>
      <VisaIcon className={setClass(isVisa)} />
      <MastercardIcon className={setClass(isMC)} />
      <DiscoverIcon className={setClass(isDiscover)} />
      <AmexIcon className={setClass(isAmex)} />
    </div>
  );

});
